import { render, staticRenderFns } from "./NsCurrency.vue?vue&type=template&id=1310b5d7"
import script from "./NsCurrency.vue?vue&type=script&lang=js"
export * from "./NsCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports